import { connect } from 'react-redux';
import { getCurrentAdSafety, getSafetyState } from '../../../../Ads/redux/selectors';
const mapStateToProps = (state)=>({
        adSafety: getCurrentAdSafety(state) || 'off',
        adSafetyState: getSafetyState(state)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
